import * as concorde from '@epilot/concorde-elements'
import React from 'react'
import ReactDOM from 'react-dom'

/**
 * This function exposes some packages globally to be used by other scripts
 * ex. Corncorde is exposed here to be used by app developers without bundling it in their scripts
 *
 * TODO: lazy load instead
 */
export function setGlobalPackages() {
  window.React = React
  window.ReactDOM = ReactDOM
  window.Concorde = concorde
}
